export default __webpack_public_path__ + "static/media/avatar_dragon6.d92cd2d4.mp3";